import React from 'react';
import { CheckCircle, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import '../styles/Cursos.css';

const Cursos = () => {
  const navigate = useNavigate();

  const cursos = [
    {
      category: 'Cursos',
      items: [
        'Curso Básico e Avançado de Combate a Incêndio',
        'Curso de Evacuação de Edifícios em Risco',
        'Curso de Brigadista de Incêndio Industrial',
        'Curso de Primeiros Socorros',
        'Higiene e Segurança no Trabalho',
        'Curso de Trabalhos em Altura',
        '5S(Senso de utilização, Senso de Ordenação, Senso de Limpeza, Senso de Saúde e Segurança, Senso de Autodisciplina)',
        'Curso de Trabalhos em Espaços Confinados',
        'Riscos Elétricos e Segurança',
        'Manuseio de Produtos Químicos Perigosos',
        'Busca e Salvamento nos Mais Diversos Domínios',
        'Montagem e Inspeção de Andaimes',
        'Máquinas Industriais (Gruas, Telehandler, Empilhadeiras, Bobcat)',
      ],
    },
  ];

  const accreditations = [
    'Acreditado pelo Instituto Nacional de Normalização e Qualidade (INNOQ)',
    'Certificação ISO 9001 para Gestão de Qualidade',
    'Afiliação à Associação Moçambicana de Segurança Contra Incêndios',
    'Reconhecimento pelo Ministério do Trabalho para Formação Profissional',
  ];

  return (
    <div className="cursos-page">
      <section className="page-hero" aria-label="Cabeçalho cursos">
        <div className="container">
          <span className="section-subtitle">Formação e Capacitação</span>
          <h1 className="section-title">Cursos Profissionais</h1>
          <p className="section-description">Formação certificada para equipas de segurança, brigadas de incêndio e operações industriais. Conteúdo atualizado com normas nacionais e internacionais.</p>
        </div>
      </section>
      <section className="cursos-section">
        <div className="container">
          <div className="section-header">
            <span className="section-subtitle">Formação Profissional</span>
            <h2>Nossos Cursos</h2>
            <p>Capacite sua equipe com treinamentos certificados em segurança contra incêndios e operações industriais.</p>
          </div>

          <div className="cursos-grid">
            {cursos.map((curso, index) => (
              <div key={index} className="curso-card" style={{ animationDelay: `${index * 0.2}s` }}>
                <h3>Área de {curso.category}</h3>
                <ul className="curso-list">
                  {curso.items.map((item, itemIndex) => (
                    // eslint-disable-next-line jsx-a11y/no-redundant-roles
                    <li key={itemIndex} role="listitem">
                      <CheckCircle size={20} />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="cta-container">
            <button
              className="btn-primary"
              onClick={() => navigate('/contatos')}
              aria-label="Solicitar informações sobre cursos"
            >
              Solicitar Informações
              <ArrowRight size={20} />
            </button>
          </div>
        </div>
      </section>

      <section className="accreditations-section">
        <div className="container">
          <div className="section-header">
            <span className="section-subtitle">Credibilidade</span>
            <h2>Nossas Acreditações</h2>
            <p>Garantimos qualidade e conformidade com padrões nacionais e internacionais.</p>
          </div>
          <div className="accreditations-card">
            <ul className="accreditations-list">
              {accreditations.map((item, index) => (
                // eslint-disable-next-line jsx-a11y/no-redundant-roles
                <li key={index} role="listitem">
                  <CheckCircle size={20} />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Cursos;